import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Terms() {
	return (
		<main className="min-h-screen bg-white">
			<Helmet>
				<title>利用規約 | しろぬきや</title>
			</Helmet>
			<header className="border-b border-gray-100 bg-white sticky top-0 z-10">
				<div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-2">
					<Link
						to="/"
						className="flex items-center gap-2 hover:opacity-80 transition"
					>
						<span className="text-2xl">✂️</span>
						<span className="font-bold text-lg text-gray-900">しろぬきや</span>
					</Link>
				</div>
			</header>

			<div className="max-w-3xl mx-auto px-4 py-12">
				<h1 className="text-3xl font-bold text-gray-900 mb-2">利用規約</h1>
				<p className="text-sm text-gray-500 mb-10">最終更新日: 2026年3月15日</p>

				<div className="space-y-8 text-gray-700 leading-relaxed">
					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							第1条（適用）
						</h2>
						<p>
							本利用規約（以下「本規約」）は、しろぬきや（以下「本サービス」）の利用条件を定めるものです。
							利用者は本規約に同意の上、本サービスをご利用ください。本サービスは個人運営（fucina.casa）によるものです。
						</p>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							第2条（サービス概要）
						</h2>
						<p>
							本サービスは、AI技術を用いた画像背景除去サービスです。ブラウザ上でAIモデルを実行し、
							ユーザーがアップロードした画像から背景を自動的に除去する機能を提供します。
							画像処理はブラウザ内で完結し、サーバーへ送信されません。
							また、各ECモール・SNSの規格サイズへの自動変換機能を提供します。
						</p>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							第3条（免責事項）
						</h2>
						<ul className="list-disc list-inside space-y-2">
							<li>
								本サービスは画像処理結果の品質・精度を保証しません。AIモデルの特性上、処理結果が期待と異なる場合があります。
							</li>
							<li>
								システムメンテナンス、障害、その他の事情によりサービスが中断・終了する場合があります。
							</li>
							<li>
								本サービスの利用によって生じた損害について、運営者は一切の責任を負いません。
							</li>
							<li>
								外部サービス（Stripe、Google
								Analytics等）の障害・変更による影響について、運営者は責任を負いません。
							</li>
						</ul>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							第4条（禁止事項）
						</h2>
						<p className="mb-2">利用者は以下の行為を行ってはなりません。</p>
						<ul className="list-disc list-inside space-y-2">
							<li>不正アクセスまたはそれに準ずる行為</li>
							<li>
								サーバーへの過度な負荷をかける行為（大量自動リクエスト等）
							</li>
							<li>違法なコンテンツ（著作権侵害、わいせつ物等）の処理</li>
							<li>他のユーザーへの妨害行為</li>
							<li>本サービスの運営を妨害する行為</li>
							<li>その他、法令または公序良俗に反する行為</li>
						</ul>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							第5条（知的財産権）
						</h2>
						<p>
							利用者がアップロードした画像の著作権その他の知的財産権は、利用者または正当な権利者に帰属します。
							本サービスは画像処理のためにのみ使用し、第三者への提供・公開は行いません。
							本サービス自体のコンテンツ（デザイン、UIテキスト等）の著作権は運営者に帰属します。
						</p>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							第6条（有料プラン）
						</h2>
						<p>
							有料プランの決済はStripe社のサービスを通じて行われます。
							サブスクリプションのキャンセルはStripeのカスタマーポータルから行えます。
							返金には対応しておりません。
						</p>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							第7条（規約の変更）
						</h2>
						<p>
							運営者は必要に応じて本規約を変更することがあります。
							変更後の規約は本ページに掲載された時点より効力を持ちます。
						</p>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							第8条（準拠法・管轄裁判所）
						</h2>
						<p>
							本規約は日本法に準拠します。本サービスに関して紛争が生じた場合、
							運営者の所在地を管轄する日本国内の裁判所を専属的合意管轄とします。
						</p>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							第9条（お問い合わせ）
						</h2>
						<p>
							本規約に関するお問い合わせは
							<Link
								to="/contact"
								className="text-blue-600 hover:underline mx-1"
							>
								お問い合わせページ
							</Link>
							よりご連絡ください。
						</p>
					</section>
				</div>
			</div>

			<footer className="text-center py-8 text-gray-400 text-sm border-t border-gray-100">
				<p>© 2026 しろぬきや</p>
				<div className="mt-2 flex justify-center gap-4">
					<Link to="/terms" className="hover:text-gray-600 transition">
						利用規約
					</Link>
					<Link to="/privacy" className="hover:text-gray-600 transition">
						プライバシーポリシー
					</Link>
					<Link to="/tokushoho" className="hover:text-gray-600 transition">
						特定商取引法に基づく表記
					</Link>
					<Link to="/contact" className="hover:text-gray-600 transition">
						お問い合わせ
					</Link>
				</div>
			</footer>
		</main>
	);
}
